<template>
  <collapse :active-index="0">
    <collapse-item body-classes="p-0 m-0">
      <template slot="title">
        <div class="row align-items-center">
          <div class="col-sm-4">
            <h3 class="mb-0">{{ title }}</h3>
          </div>

          <div class="col text-right mr-5">
            <slot name="actions"></slot>
          </div>
        </div>
      </template>

      <div></div>

      <div class="table-responsive">
        <el-table :data="tableData" header-row-class-name="thead-light" row-key="id">
          <el-table-column label="Campaña" min-width="145px" prop="campaign">
            <template #default="{ row }">
              <div class="font-weight-bold">{{ row.campaign.name }}</div>
            </template>
          </el-table-column>

          <el-table-column label="Cultivo" min-width="145px" prop="crop">
            <template #default="{ row }">
              <div>{{ row.crop.name }}</div>
            </template>
          </el-table-column>

          <el-table-column label="Cantidad" min-width="145px" prop="quantity">
            <template #default="{ row }">
              <span>{{ row.quantity }}</span
              >&nbsp;
              <span class="font-weight-bold"> ({{ row.crop.unit.toLowerCase() }})</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </collapse-item>
  </collapse>
</template>

<script>
import { Table, TableColumn, DropdownMenu, DropdownItem, Dropdown, Select, Option } from 'element-ui';
import Collapse from '@/components/Collapse/Collapse';
import CollapseItem from '@/components/Collapse/CollapseItem';

export default {
  components: {
    Collapse,
    CollapseItem,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Select.name]: Select,
    [Option.name]: Option,
  },

  props: {
    title: {
      type: String,
      default: 'Totales por cultivo',
    },

    campaign: {
      type: Number,
      default: null,
    },
  },

  data() {
    return {
      results: [],
    };
  },

  computed: {
    tableData() {
      return this.results;
    },
  },

  created() {
    this.fetchResults();
  },

  methods: {
    fetchResults() {
      this.$services
        .resource('projection_statistics')
        .cropTotals({ 'filter[campaign]': this.campaign })
        .then((res) => res.data.data)
        .then((data) => (this.results = data.results));
    },

    downloadPdf() {
      let filename = this.title.replaceAll(' ', '-').toLowerCase();
      this.$services
        .resource('projection_statistics')
        .getCropsTotalsPdf({ 'filter[campaign]': this.campaign }, filename);
    },
  },
};
</script>
